export default __webpack_public_path__ + "static/media/IMG_20200705_213959.51ab69d1.jpg";